import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../QuizHub/QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import hh from "../../images/hub-img.webp";
import cc from "../../images/hub-card.webp";
import gg from "../../images/gift-green.svg";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL } from "../../config";
import { slugify } from '../../utils/slugify';
import arr from "../../images/downarr.svg"

function HubFinal({slug,token,onsignup,onLoginChange,userdetail}) {

    const [HubFinal, setHubFinal] = useState(null);

    const [blog, setblog] = useState([]);

    const [archetype,setarchetype]= useState([]);

    const [faqData,setfaqData]= useState([]);

    const [loading, setLoading] = useState(true);

    const [openIndex, setOpenIndex] = useState(0);

    const [CarrerModal, setCarrerModal] = useState(false);
    const [careerContent, setCareerContent] = useState("");

    useEffect(() => {
        fetchHub();
    }, [slug]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


    const fetchHub = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${END_URL}/hub-final/${slug}`
            );

            setHubFinal(response.data.hub_final);
            setfaqData(response.data.quiz_faq);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {

        return (

                <div className="loadingDiv" >
                
                    <img src={ff}  alt="Loading..." />
        
                </div>
        );
    }

    const careerCards = [
    {
      image: HubFinal?.career_image_1,
      content: HubFinal?.career_content_1,
      buttonLabel: HubFinal?.career_button_label_1,
      buttonLink: HubFinal?.career_button_link_1,
    },
    {
      image: HubFinal?.career_image_2,
      content: HubFinal?.career_content_2,
      buttonLabel: HubFinal?.career_button_label_2,
      buttonLink: HubFinal?.career_button_link_2,
    },
    {
      image: HubFinal?.career_image_3,
      content: HubFinal?.career_content_3,
      buttonLabel: HubFinal?.career_button_label_3,
      buttonLink: HubFinal?.career_button_link_3,
    },
    {
      image: HubFinal?.career_image_4,
      content: HubFinal?.career_content_4,
      buttonLabel: HubFinal?.career_button_label_4,
      buttonLink: HubFinal?.career_button_link_4,
    },
    {
      image: HubFinal?.career_image_5,
      content: HubFinal?.career_content_5,
      buttonLabel: HubFinal?.career_button_label_5,
      buttonLink: HubFinal?.career_button_link_5,
    },
    {
      image: HubFinal?.career_image_6,
      content: HubFinal?.career_content_6,
      buttonLabel: HubFinal?.career_button_label_6,
      buttonLink: HubFinal?.career_button_link_6,
    },
  ].filter(card => card.content);

  return (
    <>
    <div className="hub-main final-template">
      <div className="ques-main hub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">
              <div className="ques-top" style={{'--banner_image': `url(${IMG_URL}/d0/${HubFinal?.hub_banner})`}}>
          
                <div className="ques-top-title">
                
                  <div className="quiz-banner-content" dangerouslySetInnerHTML={{__html:HubFinal?.hub_content}}/>

                  <div className="hub-banner-bnts">

                    {HubFinal?.hub_explore_btn && HubFinal?.hub_explore_link && (
                      <a href={`/${HubFinal?.hub_explore_link}`} class="new-commom-btn homearche-explore">

                        <span>{HubFinal?.hub_explore_btn}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    )}

                    {HubFinal?.hub_reveal_btn && HubFinal?.hub_reveal_link && (

                      <a href={`/${HubFinal?.hub_reveal_link}`} class="new-commom-btn hub-banner-reveal">

                        <span>{HubFinal?.hub_reveal_btn}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>

                    )}

                  </div>

                  <div dangerouslySetInnerHTML={{__html:HubFinal?.hub_reveal_content}}/>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hub-section">
        <div className="container">
          <div className="row hub-list-row">
            <div className="col-md-6">

              <div className="hub-list-div">

                <div className="hub-reveal" dangerouslySetInnerHTML={{__html:HubFinal?.hub_pattern_content}} />

                {HubFinal?.hub_pattern_btn && HubFinal?.hub_pattern_link && (
                  <a href={`/${HubFinal?.hub_pattern_link}`} class="new-commom-btn hub-banner-reveal">

                    <span>{HubFinal?.hub_pattern_btn}</span>

                    <span class="righ-arr">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </a>
                )}

              </div>
            </div>

            <div className="col-md-6">
              <div className="hub-list-image">
                <img src={`${IMG_URL}/d0/${HubFinal?.hub_reveal_image}`} alt="" />
              </div>
            </div>
          </div>

          <div className="row hub-pattern-card-row">

            <div className="hub-pattern-card-title">

              <span>
                <img src={`${IMG_URL}/d0/${HubFinal?.hub_career_icon}`} alt="" />
              </span>
              
              <h2>{HubFinal?.hub_career_title}</h2>

            </div>

            <div className="hub-pattern-card-outer">

                {careerCards?.map((card, index) => (
                  <div className="hub-pattern-cards" key={index}>
                    <div>
                      <img
                        src={`${IMG_URL}/d0/${card.image}`}
                        alt=""
                      />
                    </div>

                    <div className="hub-pattern-cards-content">
                      <div
                        className="hub-carrer-content"
                        dangerouslySetInnerHTML={{
                          __html: card.content,
                        }}
                      />

                      {card.buttonLink && card.buttonLabel && (

                        <a href={`/${card.buttonLink}`}  className="new-commom-btn hub-banner-reveal" >
                        
                          <span>{card.buttonLabel}</span>

                          <span className="righ-arr">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>
                      )}
                    </div>
                  </div>
                ))}

            </div>

          </div>



            <div className="row hub-pattern-popular">
                      
                <div className="hub-pattern-card-title">
                <span>
                    <img src={`${IMG_URL}/d0/${HubFinal?.common_role_title_icon}`} alt="" />
                </span>
                    
                    <div className="aeche-type-title">

                            <h2>{HubFinal?.common_role_title}</h2>
                    </div>
    
                </div>
    
              <div className="hub-pattern-card-outer hub-pattern-card-outer-poular">

                    {[1, 2, 3].map((num) => (

                        <div className="hub-pattern-cards" key={num}>
                            <div>
                                <img
                                    src={`${IMG_URL}/d0/${HubFinal?.[`common_role_icon_${num}`]}`}
                                    alt=""
                                />
                            </div>

                            <div className="hub-pattern-cards-content">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: HubFinal?.[`common_role_conetent_${num}`] || "",
                                    }}
                                />
                            </div>
                        </div>

                    ))}

                </div>
    
            </div>


            <div className="row job-roles">
                      
        
              <div className="hub-pattern-card-outer hub-pattern-card-outer-poular">

                        <div className="col-6 job-outer">

                            <div className="hub-pattern-cards-content">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: HubFinal?.job_content || "",
                                    }}
                                />
                            </div>

                        </div>

                        <div className="col-6 job-outer">

                            <div className="remember-image">
                                <img
                                    src={`${IMG_URL}/d0/${HubFinal?.remember_icon}`}
                                    alt=""
                                />
                            </div>

                            <div className="hub-pattern-cards-content remember-content">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: HubFinal?.remember_content || "",
                                    }}
                                />
                            </div>

                        </div>

                </div>
    
            </div>


           <div className="row hub-faq-question">

              <div className="hub-pattern-card-title faq-title-head">

                <span>

                  <img src={`${IMG_URL}/d0/${HubFinal.quiz_faq_icon}`} alt="" />

                </span>

                  <div dangerouslySetInnerHTML={{__html:HubFinal?.faq_content}} />

              </div>

              <div className="col-12 col-sm-12 col-md-12">

                <div className="faq-container">

                  {faqData?.map((item, index) => (
                      <div key={index} className="faq-item" onClick={() => toggle(index)}>
                        <div className="faq-title">
                          <h3>{item.question}</h3>
                          <span className="arrow-icon">
                            <img className={openIndex === index ? "rotate1" : ""} src={arr} alt="" />
                          </span>
                        </div>
                        {openIndex === index && (
                          <div className="faq-content">
                            <p dangerouslySetInnerHTML={{ __html: item?.answer }}></p>
                          </div>
                        )}
                        <hr />
                      </div>

                  ))}
                </div>
              </div>


            </div>

            {HubFinal?.footer_content && (

                <div className="row ">

                    <div className="adapter-cta-div adapter-cta-div-in-ebook">

                    {HubFinal?.footer_icon && ( 

                        <div className="adapt-cta-img">
                            <div>
                                <span>
                                    <img src={`${IMG_URL}/d0/${HubFinal?.footer_icon}`} alt="" />
                                </span>
                            </div>
                        </div>
                    )}
        
                    <div className="adapt-cta-text" dangerouslySetInnerHTML={{__html:HubFinal?.footer_content}}/>
                
                        {HubFinal?.footer_button_label && HubFinal?.footer_button_link && (

                            <div className="adapt-cta-btn">
        
                                <a href={`${HubFinal?.footer_button_link}`} class="new-commom-btn adapter-btn">
                
                                    <span>{HubFinal?.footer_button_label}</span>
                
                                    <span class="righ-arr">
                
                                    <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>

                            </div>
                        )}

                    </div>
                </div>
            )}

        </div>
      </div>
    </div>

      {CarrerModal && (
        <div className="newdashpop-overlay lock-dashboard carrer-banner">
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => {
                  setCarrerModal(false);
                  setCareerContent("");
                }}
              >
                &times;
              </button>

              <div className="conent-pop lock-dashboard-content">
                <div className="dash-loc-title">

                  <div
                    dangerouslySetInnerHTML={{ __html: careerContent }}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
}

export default HubFinal;
